<template>
  <div class="index">
    <div class="pc clearfix">
      <app-header :oneList="oneList"></app-header>
      <div class="centers">
        <div class="content">
          <!-- 城市 -->
          <div class="city">
            <ul class="clearfix" v-if="cityList.length > 0">
              <li
                class="fl"
                v-for="(items, key) in cityList.slice(0, 32)"
                :key="key + 'qw'"
              >
                <router-link
                  target="_blank"
                  :to="{ path: '/city', query: { cityId: items.id } }"
                  >{{ items.sname }}</router-link
                >
              </li>
            </ul>
          </div>
          <!-- 公告栏 -->
          <div class="announcement clearfix">
            <img class="fl" src="../assets/imgs/Shape 2.png" alt="公告" />
            <span class="titles fl">公告栏：</span>
            <div class="announcementContent">
              <ul
                class="fl animate clearfix"
                v-if="JSON.stringify(twoList).length > 2"
              >
                <li v-for="(items, i) in twoList" :key="i + '1'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '2'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '3'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '4'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '5'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '6'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '7'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '8'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '9'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
                <li v-for="(items, i) in twoList" :key="i + '10'" class="fl">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    >{{ items.title }}</router-link
                  ><span>|</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 推荐 -->
          <div
            class="recommend"
            v-if="JSON.stringify(threeListLeft).length > 2"
          >
            <div class="recommendLeft fl">
              <p>{{ recommendTitle }}</p>
            </div>
            <div class="recommendCon fl">
              <h3 v-if="threeListLeft">
                <router-link
                  target="_blank"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: threeListLeft[0].recruitId },
                  }"
                  >{{ threeListLeft[0].title }}</router-link
                >
              </h3>
              <ul>
                <li v-if="threeListLeft">
                  <span>{{ recommendChildTitle1 }} | </span
                  ><router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: threeListLeft[1].recruitId },
                    }"
                    ><i>{{ threeListLeft[1].title }}</i></router-link
                  >
                </li>
                <li v-if="threeListLeft">
                  <span>{{ recommendChildTitle2 }} | </span
                  ><router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: threeListLeft[2].recruitId },
                    }"
                    ><i>{{ threeListLeft[2].title }}</i></router-link
                  >
                </li>
                <li v-if="threeListLeft">
                  <span>{{ recommendChildTitle3 }} | </span
                  ><router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: threeListLeft[3].recruitId },
                    }"
                    ><i>{{ threeListLeft[3].title }}</i></router-link
                  >
                </li>
              </ul>
            </div>
            <div class="recommendCon fl">
              <h3 v-if="threeListRight">
                <router-link
                  target="_blank"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: threeListRight[0].recruitId },
                  }"
                  >{{ threeListRight[0].title }}</router-link
                >
              </h3>
              <ul>
                <li v-if="threeListRight">
                  <span>{{ recommendChildTitle1 }} | </span
                  ><router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: threeListRight[1].recruitId },
                    }"
                    ><i>{{ threeListRight[1].title }}</i></router-link
                  >
                </li>
                <li v-if="threeListRight">
                  <span>{{ recommendChildTitle2 }} | </span
                  ><router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: threeListRight[2].recruitId },
                    }"
                    ><i>{{ threeListRight[2].title }}</i></router-link
                  >
                </li>
                <li v-if="threeListRight">
                  <span>{{ recommendChildTitle3 }} | </span
                  ><router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: threeListRight[3].recruitId },
                    }"
                    ><i>{{ threeListRight[3].title }}</i></router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- 动态 -->
          <div class="dynamic clearfix">
            <!-- 左侧 -->
            <div class="dynamic_left fl">
              <div
                class="left_carousel"
                v-if="JSON.stringify(left_carousel_list).length > 2"
              >
                <el-carousel :interval="5000" height="250px" arrow="never">
                  <el-carousel-item
                    v-for="(item, i) in left_carousel_list"
                    :key="i + '2a'"
                  >
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/jobDetail',
                        query: { jobDetailId: item.recruitId },
                      }"
                      ><img
                        style="width: 428px; height: 250px"
                        :src="item.img"
                        alt="科研人才网-科研院所硕博行政岗位人才招聘"
                    /></router-link>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div
                class="left_company"
                v-if="JSON.stringify(threeLeftBot).length > 2"
              >
                <ul class="clearfix">
                  <li
                    class="fl"
                    v-for="(items, i) in threeLeftBot"
                    :key="i + 'ac'"
                  >
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/jobDetail',
                        query: { jobDetailId: items.recruitId },
                      }"
                      ><img :src="items.img" alt="科研人才网-医药卫生硕士博士科研人才招聘"
                    /></router-link>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 中间 动态 -->
            <div class="dynamic_center fl">
              <p class="dynamic_center_title clearfix">
                <span
                  @click="changeDynamic(1)"
                  class="fl"
                  :class="{ actived: changeDynamicFlag == 1 }"
                  >{{ dynamicTitle3 }}</span
                >
                <!-- <span @click="changeDynamic(2)" class="fl" :class="{'actived':changeDynamicFlag == 2}">{{dynamicTitle2}}</span> -->
                <span
                  @click="changeDynamic(5)"
                  class="fl"
                  :class="{ actived: changeDynamicFlag == 5 }"
                  >{{ dynamicTitle4 }}</span
                >
                <span
                  @click="changeDynamic(4)"
                  class="fl"
                  :class="{ actived: changeDynamicFlag == 4 }"
                  >职场情报</span
                >
              </p>
              <div
                v-show="
                  changeDynamicFlag == 1 &&
                  JSON.stringify(newPosition).length > 2
                "
                class="dynamic_center_content"
              >
                <p
                  class="clearfix"
                  v-for="(items, i) in newPosition.slice(0, 17)"
                  :key="i + 'fd'"
                >
                  <span class="circle fl"></span>
                  <router-link
                    class="fl"
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                    style="width: 350px"
                  >
                    <span>{{ items.title }}</span>
                  </router-link>
                  <span
                    class="detailTime fr"
                    v-html="
                      parseInt(items.createTime.slice(5, 7)) +
                      '/' +
                      items.createTime.slice(8, 10)
                    "
                  ></span>
                </p>
                <p class="more" v-if="newPosition.length >= 17">
                  <router-link target="_blank" to="/newPositions"
                    >查看更多>></router-link
                  >
                </p>
              </div>
              <!-- 最新求职者 -->
              <!-- <div v-show="changeDynamicFlag == 2 && JSON.stringify(newJobSeeker).length > 2" class="dynamic_center_content"> 
                            <p class="clearfix" v-for="(items, i) in newJobSeeker.slice(0,18)" :key="i+'nv'">
                                <span class="circle fl"></span>
                                <router-link target="_blank" :to="{path:'/jobDetail',query:{jobDetailId:items.recruitId}}" class="fl">
                                    <span>{{items.userName|formatName}}</span><i>&nbsp;&nbsp;{{items.school}}/{{items.education}}</i><span>&nbsp;&nbsp;{{items.address}}&nbsp;&nbsp;{{items.arrivalTime}}可入职</span>
                                </router-link>
                            </p>
                        </div> -->

              <!-- <div v-show="changeDynamicFlag == 3" class="dynamic_center_content">
                            <p class="clearfix" v-for="(items, i) in newPosition.slice(0,18)" :key="i">
                                <span class="circle fl"></span>
                                <router-link class="fl" target="_blank" :to="{path:'/jobDetail',query:{jobDetailId:items.recruitId}}">
                                    <span>{{items.title}}</span>
                                </router-link>
                                <span class="detailTime fr" v-html="items.createTime.slice(0,10)"></span>
                            </p>
                        </div> -->
              <div
                v-show="
                  changeDynamicFlag == 4 &&
                  JSON.stringify(personnelList).length > 2
                "
                class="dynamic_center_content"
              >
                <!-- 人事动态 -->
                <p
                  class="clearfix"
                  v-for="(items, i) in personnelList.slice(0, 17)"
                  :key="i + 'qw'"
                >
                  <span class="circle fl"></span>
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                  >
                    <span>{{ items.title }}</span>
                  </router-link>
                </p>
                <p class="more" v-if="personnelList.length >= 17">
                  <router-link target="_blank" to="/intelligence"
                    >查看更多>></router-link
                  >
                </p>
              </div>
              <div
                v-show="
                  changeDynamicFlag == 5 && JSON.stringify(hotJobs).length > 2
                "
                class="dynamic_center_content"
              >
                <!-- 求职热点 -->
                <p
                  class="clearfix"
                  v-for="(items, i) in hotJobs.slice(0, 17)"
                  :key="i + 'lq'"
                >
                  <span class="circle fl"></span>
                  <router-link
                    class="fl"
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                  >
                    <span>{{ items.title }}</span>
                  </router-link>
                </p>
                <p class="more" v-if="hotJobs.length >= 17">
                  <router-link target="_blank" to="/hotPositions"
                    >查看更多>></router-link
                  >
                </p>
              </div>
            </div>
            <!-- 右侧 -->
            <div
              class="dynamic_right fl clearfix"
              v-if="JSON.stringify(threeRight).length > 2"
            >
              <router-link
                target="_blank"
                :to="{
                  path: '/jobDetail',
                  query: { jobDetailId: items.recruitId },
                }"
                v-for="(items, i) in threeRight.slice(0, 8)"
                class="fl"
                :key="i"
              >
                <img :src="items.img" alt="科研人才网-知名企业硕士博士科研人才招聘" />
                <p>{{ items.title }}</p>
              </router-link>
            </div>
          </div>
          <!-- 高校人才 科研人才招聘 -->
          <div class="talent clearfix">
            <div class="talent_left fl">
              <p class="talent_title">高等院校招聘</p>
              <div
                class="talent_list clearfix"
                v-if="JSON.stringify(heightImg).length > 2"
              >
                <router-link
                  target="_blank"
                  class="fl"
                  v-for="(items, i) in heightImg"
                  :key="i + 'na'"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                >
                  <img :src="items.img" alt="科研人才网-事业单位硕士博士科研人才招聘" />
                </router-link>
              </div>
              <div class="talent_con">
                <router-link
                  target="_blank"
                  v-for="(items, i) in heightMsg.slice(0, 3)"
                  :key="i + '12'"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  class="diff clearfix"
                >
                  <span class="circle fl"></span>
                  <span v-if="i <= 2" class="topping fl">[置顶信息]</span>
                  <span class="title fl">{{ items.title }}</span>
                </router-link>
                <router-link
                  target="_blank"
                  v-for="(items, i) in talent11.slice(0, 12)"
                  :key="i + 'xb'"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  class="clearfix"
                >
                  <span class="circle fl"></span>
                  <span class="title fl">{{ items.title }}</span>
                </router-link>
                <p class="more">
                  <router-link target="_blank" to="/university"
                    >查看更多>></router-link
                  >
                </p>
              </div>
            </div>
            <div class="talent_right fr">
              <p class="talent_title talent_title2">科研院所招聘</p>
              <div
                class="talent_list clearfix"
                v-if="JSON.stringify(talentImg).length > 2"
              >
                <router-link
                  target="_blank"
                  class="fl"
                  v-for="(items, i) in talentImg"
                  :key="i + 'ga'"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                >
                  <img :src="items.img" alt="科研人才网-硕士博士科研专项人才引进" />
                </router-link>
              </div>
              <div class="talent_con">
                <router-link
                  target="_blank"
                  v-for="(items, i) in talentMsg.slice(0, 3)"
                  :key="i + 'xu'"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  class="diff clearfix"
                >
                  <span class="circle fl"></span>
                  <span v-if="i <= 2" class="topping fl">[置顶信息]</span>
                  <span class="title fl">{{ items.title }}</span>
                </router-link>
                <router-link
                  target="_blank"
                  v-for="(items, i) in talent12.slice(0, 12)"
                  :key="i + '0i'"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  class="clearfix"
                >
                  <span class="circle fl"></span>
                  <span class="title fl">{{ items.title }}</span>
                </router-link>
                <p class="more">
                  <router-link target="_blank" to="/researchInstitute"
                    >查看更多>></router-link
                  >
                </p>
              </div>
            </div>
          </div>

          <div
            class="comList clearfix"
            v-if="JSON.stringify(sixList).length > 2"
          >
            <router-link
              target="_blank"
              class="fl"
              v-for="(items, i) in sixList"
              :to="{
                path: '/jobDetail',
                query: { jobDetailId: items.recruitId },
              }"
              :key="i"
            >
              <img :src="items.img" alt="科研人才网-事业单位硕士博士人才招聘" />
              <p>{{ items.title }}</p>
            </router-link>
          </div>
          <!-- 行业动态 -->
          <div class="industryMsg">
            <div class="indestry_title clearfix">
              <h3 class="fl">{{ dynamicTitle5 }}</h3>
              <p class="fl">
                <span
                  :class="{ actived1: indestryFlag == 1 }"
                  @click="indestryFlag = 1"
                  >{{ dynamicTitle22 }}</span
                >
                <!-- <span :class="{actived1:indestryFlag == 2}" @click="indestryFlag = 2">最新求职者</span> -->
                <!-- <span :class="{actived1:indestryFlag == 3}" @click="indestryFlag = 3">{{dynamicTitle23}}</span>
                            <span :class="{actived1:indestryFlag == 4}" @click="indestryFlag = 4">{{dynamicTitle24}}</span>
                            <span :class="{actived1:indestryFlag == 5}" @click="indestryFlag = 5">{{dynamicTitle25}}</span>
                            <span :class="{actived1:indestryFlag == 6}" @click="indestryFlag = 6">{{dynamicTitle26}}</span> -->
              </p>
              <!-- <router-link to="" class="fr more">查看更多>></router-link> -->
            </div>
            <div class="indestry_content clearfix">
              <div class="fl indestry_content_left">
                <div class="clearfix">
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '哲学', major: 'zhe_xue' },
                    }"
                    ><span></span>哲学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '经济学', major: 'jing_ji_xue' },
                    }"
                    ><span></span>经济学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '法学', major: 'fa_xue' },
                    }"
                    ><span></span>法学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '教育学', major: 'jiao_yu_xue' },
                    }"
                    ><span></span>教育学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '文学', major: 'wen_xue' },
                    }"
                    ><span></span>文学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '历史学', major: 'li_shi_xue' },
                    }"
                    ><span></span>历史学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '理学', major: 'li_xue' },
                    }"
                    ><span></span>理学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '工学', major: 'gong_xue' },
                    }"
                    ><span></span>工学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '农学', major: 'nong_xue' },
                    }"
                    ><span></span>农学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '医学', major: 'yi_xue' },
                    }"
                    ><span></span>医学</router-link
                  >
                  <!-- <router-link target="_blank" class="fl" :to="{path:'/moreList',query:{childName:'军事类',major:'jun_shi_xue'}}"><span></span>军事类</router-link> -->
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '管理学', major: 'guan_li_xue' },
                    }"
                    ><span></span>管理学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '艺术学', major: 'yi_shu_xue' },
                    }"
                    ><span></span>艺术学</router-link
                  >
                  <router-link
                    target="_blank"
                    class="fl"
                    :to="{
                      path: '/moreList',
                      query: { childName: '其他', major: 'qi_ta' },
                    }"
                    ><span></span>其他</router-link
                  >
                </div>
              </div>
              <!-- 行业动态 -->
              <div
                v-show="indestryFlag == 1"
                v-if="industryList"
                class="fl indestry_content_right clearfix"
              >
                <router-link
                  target="_blank"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  v-for="(items, i) in industryList.slice(0, 8)"
                  class="fl"
                  :key="i + '1r'"
                >
                  <img :src="items.img" alt="科研人才网-硕士博士人才招聘" />
                  <p>{{ items.title }}</p>
                </router-link>
              </div>
            </div>
          </div>
          <!-- 博士人才 博士后人才  招聘 -->
          <div class="talent clearfix">
            <div class="talent_left fl">
              <p class="talent_title">博士人才招聘</p>
              <div class="talent_school clearfix" v-if="sevenLeftTop">
                <router-link
                  target="_blank"
                  v-for="(items, i) in sevenLeftTop"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  class="fl"
                  :key="i + '1f'"
                >
                  <img :src="items.img" alt="科研人才网-硕士科研人才招聘" />
                  <p>{{ items.title }}</p>
                </router-link>
              </div>
              <div class="talent_list clearfix" v-if="sevenLeftCenter">
                <router-link
                  target="_blank"
                  v-for="(items, i) in sevenLeftCenter"
                  class="fl"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  :key="i + 'vz'"
                >
                  <img :src="items.img" alt="科研人才网-博士科研人才招聘" />
                </router-link>
              </div>
              <div class="talent_con">
                <router-link
                  target="_blank"
                  v-for="(items, i) in sevenleftBom.slice(0, 3)"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  :key="i + 's7'"
                  class="diff clearfix"
                >
                  <span class="circle fl"></span>
                  <span v-if="i <= 2" class="topping fl">[置顶信息]</span>
                  <span class="title fl">{{ items.title }}</span>
                </router-link>
                <router-link
                  target="_blank"
                  v-for="(items, i) in talent13.slice(0, 12)"
                  :key="i + 'j6'"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  class="clearfix"
                >
                  <span class="circle fl"></span>
                  <span class="title fl">{{ items.title }}</span>
                </router-link>
                <p class="more">
                  <router-link target="_blank" to="/master"
                    >查看更多>></router-link
                  >
                </p>
              </div>
            </div>
            <div class="talent_right fr">
              <p class="talent_title talent_title2">博后进站招聘</p>
              <div class="talent_school clearfix" v-if="sevenRightTop">
                <router-link
                  target="_blank"
                  v-for="(items, i) in sevenRightTop"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  class="fl"
                  :key="i + '8a'"
                >
                  <img :src="items.img" alt="科研人才网-博后科研人才招聘" />
                  <p>{{ items.title }}</p>
                </router-link>
              </div>
              <div class="talent_list clearfix" v-if="sevenRightCenter">
                <router-link
                  target="_blank"
                  v-for="(items, i) in sevenRightCenter"
                  class="fl"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  :key="i + 'nz'"
                >
                  <img :src="items.img" alt="科研人才网-高校博后科研人才招聘" />
                </router-link>
              </div>
              <div class="talent_con" v-if="talent14.length > 0">
                <router-link
                  target="_blank"
                  v-for="(items, i) in sevenRightBom.slice(0, 3)"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  :key="i + 'dfg'"
                  class="diff clearfix"
                >
                  <span class="circle fl"></span>
                  <span v-if="i <= 2" class="topping fl">[置顶信息]</span>
                  <span class="title fl">{{ items.title }}</span>
                </router-link>
                <router-link
                  target="_blank"
                  v-for="(items, i) in talent14.slice(0, 12)"
                  :key="i + '9t'"
                  :to="{
                    path: '/jobDetail',
                    query: { jobDetailId: items.recruitId },
                  }"
                  class="clearfix"
                >
                  <span class="circle fl"></span>
                  <span class="title fl">{{ items.title }}</span>
                </router-link>
                <p class="more">
                  <router-link target="_blank" to="/postdoctoral"
                    >查看更多>></router-link
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- 人才专题 -->
          <div class="talentTopic clearfix" v-if="talentList.length > 0">
            <h3 class="fl clearfix">
              <span class="fl"></span><i class="fl">{{ dynamicTitle9 }}</i>
            </h3>
            <router-link
              class="talentTopic_block fl"
              target="_blank"
              v-for="(items, i) in talentList.slice(0, 5)"
              :key="i + '0z'"
              :to="{
                path: '/jobDetail',
                query: { jobDetailId: items.recruitId },
              }"
            >
              <div>
                <img :src="items.img" alt="科研人才网-研究院博后科研人才招聘" />
                <p>{{ items.title }}</p>
              </div>
            </router-link>
          </div>
          <!-- 求职者推荐 暂不做 -->
          <!-- 人事热点 最新更新 求职动态-->
          <div class="hotSpot clearfix">
            <div class="hotSpot_left fl">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">{{ dynamicTitle12 }}</i>
              </h3>
              <ul v-if="talent15.length > 0">
                <li v-for="(items, i) in talent15.slice(0, 15)" :key="i + 'p'">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                  >
                    <span class="circle"></span><i>{{ items.title }}</i>
                  </router-link>
                </li>
              </ul>
              <p class="more">
                <router-link target="_blank" to="/medicine"
                  >查看更多>></router-link
                >
              </p>
            </div>
            <!-- 最新更新 -->
            <div class="hotSpot_center fl">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">{{ dynamicTitle13 }}</i>
              </h3>
              <ul v-if="talent16.length > 0">
                <li v-for="(items, i) in talent16.slice(0, 15)" :key="i + 'l'">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                  >
                    <span class="circle"></span><i>{{ items.title }}</i>
                  </router-link>
                </li>
              </ul>
              <p class="more">
                <router-link target="_blank" to="/famousCom"
                  >查看更多>></router-link
                >
              </p>
            </div>
            <!-- 求职动态 -->
            <div class="hotSpot_right fr">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">{{ dynamicTitle14 }}</i>
              </h3>
              <ul v-if="talent17.length > 0">
                <li v-for="(items, i) in talent17.slice(0, 15)" :key="i + 'o'">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                  >
                    <span class="circle"></span><i>{{ items.title }}</i>
                  </router-link>
                </li>
              </ul>
              <p class="more">
                <router-link target="_blank" to="/Institution"
                  >查看更多>></router-link
                >
              </p>
            </div>
          </div>
          <!-- 国外博士 -->
          <div class="hotSpot clearfix">
            <div class="hotSpot_left fl">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">国外博士项目</i>
              </h3>
              <ul v-if="talent21.length > 0">
                <li v-for="(items, i) in talent21.slice(0, 15)" :key="i + 'p1'">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                  >
                    <span class="circle"></span><i>{{ items.title }}</i>
                  </router-link>
                </li>
              </ul>
              <p class="more">
                <router-link
                  target="_blank"
                  :to="{
                    path: '/moreList',
                    query: {
                      parentUrl: '/foreignProjects',
                      childName: '博士招生',
                      parentName: '国外项目',
                      categoryCode: 'bo_shi_zhao_sheng',
                    },
                  }"
                  >查看更多>></router-link
                >
              </p>
            </div>
            <div class="hotSpot_center fl">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">国外博后/教职</i>
              </h3>
              <ul v-if="talent22.length > 0">
                <li v-for="(items, i) in talent22.slice(0, 15)" :key="i + 'l'">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                  >
                    <span class="circle"></span><i>{{ items.title }}</i>
                  </router-link>
                </li>
              </ul>
              <p class="more">
                <router-link
                  target="_blank"
                  :to="{
                    path: '/moreList',
                    query: {
                      parentUrl: '/foreignProjects',
                      childName: '博后/研究员招聘',
                      parentName: '国外项目',
                      categoryCode: 'bo_hou_huo_yan_jiu_yuan_zhao_ping',
                    },
                  }"
                  >查看更多>></router-link
                >
              </p>
            </div>
            <div class="hotSpot_right fr">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">国外访学项目</i>
              </h3>
              <ul v-if="talent23.length > 0">
                <li v-for="(items, i) in talent23.slice(0, 15)" :key="i + 'o'">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/jobDetail',
                      query: { jobDetailId: items.recruitId },
                    }"
                  >
                    <span class="circle"></span><i>{{ items.title }}</i>
                  </router-link>
                </li>
              </ul>
              <p class="more">
                <router-link
                  target="_blank"
                  :to="{
                    path: '/moreList',
                    query: {
                      parentUrl: '/foreignProjects',
                      childName: '访问学者',
                      parentName: '国外项目',
                      categoryCode: 'fang_wen_xue_zhe',
                    },
                  }"
                  >查看更多>></router-link
                >
              </p>
            </div>
          </div>
          <!-- 职场充能 -->
          <router-link
            target="_blank"
            :to="{
              path: '/jobDetail',
              query: { jobDetailId: nineList[0].recruitId },
            }"
            v-if="nineList.length > 0"
            class="onlyImg"
            ><img :src="nineList[0].img" alt="科研人才网-企业博后科研人才招聘"
          /></router-link>
          <!-- 职场聚焦 -->
          <div class="workPlace clearfix">
            <div class="workModule fl" v-if="personnelList.length > 0">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">职场情报</i>
              </h3>
              <div class="clearfix">
                <ul class="fl">
                  <li
                    v-for="(items, i) in personnelList.slice(0, 15)"
                    :key="i + 'kaj2'"
                  >
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/jobDetail',
                        query: { jobDetailId: items.recruitId },
                      }"
                      ><span class="circle"></span
                      ><i>{{ items.title }}</i></router-link
                    >
                  </li>
                </ul>
                <p class="more">
                  <router-link target="_blank" to="/intelligence"
                    >查看更多>></router-link
                  >
                </p>
              </div>
            </div>
            <div class="workModule fl" v-if="talent19.length > 0">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">猎头特聘</i>
              </h3>
              <div class="clearfix">
                <ul class="fl">
                  <li
                    v-for="(items, i) in talent19.slice(0, 15)"
                    :key="i + '12asnd'"
                  >
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/jobDetail',
                        query: { jobDetailId: items.recruitId },
                      }"
                      ><span class="circle"></span
                      ><i>{{ items.title }}</i></router-link
                    >
                  </li>
                </ul>
                <p class="more">
                  <router-link target="_blank" to="/expert"
                    >查看更多>></router-link
                  >
                </p>
              </div>
            </div>
            <div class="workModule fl" v-if="talent24.length > 0">
              <h3 class="clearfix">
                <span class="fl"></span><i class="fl">科创专区</i>
              </h3>
              <div class="clearfix">
                <ul class="fl">
                  <li
                    v-for="(items, i) in talent24.slice(0, 15)"
                    :key="i + 'aksjdda'"
                  >
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/jobDetail',
                        query: { jobDetailId: items.recruitId },
                      }"
                      ><span class="circle"></span
                      ><i>{{ items.title }}</i></router-link
                    >
                  </li>
                </ul>
                <p class="more">
                  <router-link target="_blank" to="/science"
                    >查看更多>></router-link
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="bottomImg" v-if="JSON.stringify(eleList).length > 2">
            <p class="one">
              <router-link
                target="_blank"
                :to="{
                  path: '/jobDetail',
                  query: { jobDetailId: eleList[1][0].recruitId },
                }"
                ><img :src="eleList[1][0].img" alt="科研人才网-高级科研人才引进"
              /></router-link>
            </p>
            <p class="threee clearfix">
              <router-link
                target="_blank"
                class="fl"
                :to="{
                  path: '/jobDetail',
                  query: { jobDetailId: eleList[3][0].recruitId },
                }"
                ><img :src="eleList[3][0].img" alt="科研人才网-高校中高层管理人才引进"
              /></router-link>
              <router-link
                target="_blank"
                class="fl"
                :to="{
                  path: '/jobDetail',
                  query: { jobDetailId: eleList[3][1].recruitId },
                }"
                ><img :src="eleList[3][1].img" alt="科研人才网-高校学术带头人引进"
              /></router-link>
              <router-link
                target="_blank"
                class="fl"
                :to="{
                  path: '/jobDetail',
                  query: { jobDetailId: eleList[3][2].recruitId },
                }"
                ><img :src="eleList[3][2].img" alt="科研人才网-国外博士科研人才招聘"
              /></router-link>
            </p>
          </div>
        </div>
      </div>
      <app-ad :fiveListData="fiveList"></app-ad>
      <app-al :fiveListData="fiveList"></app-al>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { get, postWithJson, form } from "@/api/services";
import AppFooter from "../components/common/footer.vue";
import AppAd from "../components/common/addif.vue";
import AppAl from "../components/common/addil.vue";
import AppHeader from "../components/common/header2.vue";
export default {
  components: { AppFooter, AppAd, AppAl, AppHeader },
  name: "index",
  data() {
    return {
      userNmae: "",
      navFlag: false,
      indestryFlag: 1,
      loginPersonFlag: false,
      loginCompanyFlag: false,
      changeDynamicFlag: "1",
      talentFlag: 1,
      left_carousel_list: [],
      activeName: "first",
      oneList: {},
      twoList: [], //公告栏
      threeListLeft: [],
      threeListRight: [],
      personnelList: "", //职场情报
      newJobSeeker: {}, //最新求职者
      newPosition: "", //最新职位
      recommendPosition: "", //推荐职位
      hotJobs: "", //求职热点
      threeLeftBot: "",
      threeRight: "",
      fiveList: {},
      indestryList: "",
      newIndestry: "",
      sixList: "",
      cityList: "",

      sevenLeftTop: [], //博士  博士后
      sevenRightTop: [],
      sevenLeftCenter: [],
      sevenRightCenter: [],
      sevenleftBom: [],
      sevenRightBom: [],

      eightList: [],
      nineList: [],

      heightImg: [], //高校
      talent11: [],
      talent12: [],
      talent13: [],
      talent14: [],
      talent15: [],
      talent16: [],
      talent17: [],
      talent18: [],
      talent19: [],
      talent20: [],
      talent21: [],
      talent22: [],
      talent23: [],
      talent24: [],
      heightMsg: [],
      talentImg: [], //科研所
      talentMsg: [], //科研所

      // tenList:[],// 职场聚焦

      eleList: [],

      workplaceList: [], //职场聚焦
      highList: [], //高端人才招聘
      employmentList: [], //就业精华
      talentList: [], //人才专题
      // recommendList:[],// 推荐

      researchList: [], //科研机构
      digitalList: [], //人才数据

      relatedList: [], //科研相关
      industryList: [], //行业动态
      jobList: "", //分类列表
      categoryList: [], //分类主页列表
      titleList: {}, //3.1.24查询主页标题接口

      recommendTitle: "",
      recommendChildTitle: "",
      recommendChildTitle1: "",
      recommendChildTitle2: "",
      recommendChildTitle3: "",
      dynamicTitle1: "",
      dynamicTitle2: "",
      dynamicTitle3: "",
      dynamicTitle4: "",
      dynamicTitle5: "",
      dynamicTitle6: "",
      dynamicTitle7: "",
      dynamicTitle8: "",
      dynamicTitle9: "",
      dynamicTitle10: "",
      dynamicTitle11: "",
      dynamicTitle12: "",
      dynamicTitle13: "",
      dynamicTitle14: "",
      dynamicTitle15: "",
      dynamicTitle16: "",
      dynamicTitle17: "",
      dynamicTitle18: "",
      dynamicTitle19: "",
      dynamicTitle20: "",
      dynamicTitle21: "",
      dynamicTitle22: "",
      dynamicTitle23: "",
      dynamicTitle24: "",
      dynamicTitle25: "",
      dynamicTitle26: "",
    };
  },
  created: function () {
    let _self = this;
    _self.hasLogin();
    _self.initData(1); //最新求职者
  },
  filters: {
    timerFilter: function (values) {
      return values.slice(0, 10);
    },
    formatName: function (name) {
      let newStr;
      if (name.length === 2) {
        newStr = name.substr(0, 1) + "*";
      } else if (name.length > 2) {
        let char = "";
        for (let i = 0, len = name.length - 2; i < len; i++) {
          char += "*";
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1);
      } else {
        newStr = name;
      }

      return newStr;
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.getTitleList(); //3.1.24查询主页标题接口
      this.search();
      // this.initData(3);//人事动态
      this.initData(4); //求职热点
      // Code that will run only after the
      // entire view has been rendered
    });
    // 开启滚动监听
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    hasLogin() {
      let userNmae = localStorage.getItem("_userName");

      let myreg = /^1\d{10}$/;
      if (myreg.test(parseInt(userNmae))) {
        this.loginPersonFlag = true;
        this.userNmae = userNmae.slice(0, 3) + "****" + userNmae.slice(7, 12);
      }
      let myreg1 =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (myreg1.test(userNmae)) {
        this.loginCompanyFlag = true;
        this.userNmae =
          userNmae.slice(0, 3) + "****" + userNmae.slice(userNmae.indexOf("@"));
      }
    },
    search() {
      // 搜索
      let _self = this;
      var reqData = { categoryCode: 100 };
      postWithJson("front/advertises/getAdvertisesList", reqData).then(
        function (response) {
          if (response.data.status) {
            // console.log(response.data.data.length)
            if (response.data.data) {
              let resData = response.data.data;
              _self.oneList = resData[1];
              _self.twoList = resData[2][27];
              _self.threeListLeft = resData[3][32];
              _self.threeListRight = resData[3][33];
              _self.left_carousel_list = resData[4][4];
              _self.threeLeftBot = resData[4][6];
              _self.threeRight = resData[4][33];
              _self.fiveList = resData[5];
              _self.industryList = resData[6][37];
              _self.sixList = resData[7][2];
              _self.heightImg = resData[8][4];
              _self.heightMsg = resData[8][6];
              _self.talentImg = resData[8][7];
              _self.talentMsg = resData[8][9];
              _self.talentList = resData[9][2];
              _self.sevenLeftTop = resData[10][4];
              _self.sevenLeftCenter = resData[10][5];
              _self.sevenleftBom = resData[10][6];
              _self.sevenRightTop = resData[10][7];
              _self.sevenRightCenter = resData[10][8];
              _self.sevenRightBom = resData[10][9];
              _self.nineList = resData[12][2];
              _self.eleList = resData[14];

              _self.searchAfter();
            }
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );

      postWithJson("front/resumeInfo/queryResumeInfoList", {}).then(
        function (response) {
          _self.newJobSeeker = response.data.data;
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
      get("front/region/getRegion", { level: "1" }).then(
        function (response) {
          if (response.data.status) {
            _self.cityList = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
      get("front/dict/getDict", { dictType: "one_category" }).then(
        function (response) {
          if (response.data.status) {
            _self.categoryList = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
      // let reqData14 = {
      //     city:"",
      //     province:'',
      //     dictCode:'',
      //     companyId:'',
      //     desc:"",
      //     keyWord:'',
      //     categoryCode:"bo_shi_hou"
      // }
      // postWithJson('front/recruit/queryRecruit?pageNum=1&pageSize=12',reqData14).then( //博后
      //     function(response){
      //         if(response.data.status){
      //             _self.talent14 = response.data.data;
      //         }else{
      //             console.log(response.data.message);
      //         }
      //     },
      //     function(response){
      //         _self.$message({
      //             message: "请重试",
      //             type: 'error'
      //         });
      //     }
      // )
      let reqData15 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "yi_yao_wei_sheng",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData15
      ).then(
        //医药卫生
        function (response) {
          if (response.data.status) {
            _self.talent15 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData16 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "zhi_ming_qi_ye",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData16
      ).then(
        //知名企业
        function (response) {
          if (response.data.status) {
            _self.talent16 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData17 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "shi_ye_dan_wei",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData17
      ).then(
        //事业单位
        function (response) {
          if (response.data.status) {
            _self.talent17 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData18 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "zhi_ye_qing_bao",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData18
      ).then(
        //事业单位
        function (response) {
          if (response.data.status) {
            _self.talent18 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData19 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "zhuan_jia_te_ping",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData19
      ).then(
        //事业单位
        function (response) {
          if (response.data.status) {
            _self.talent19 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData20 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "she_hui_jian_zhi",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData20
      ).then(
        //事业单位
        function (response) {
          if (response.data.status) {
            _self.talent20 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );

      let reqData21 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "bo_shi_zhao_sheng",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData21
      ).then(
        //事业单位
        function (response) {
          if (response.data.status) {
            _self.talent21 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData22 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "bo_hou_huo_yan_jiu_yuan_zhao_ping",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData22
      ).then(
        //事业单位
        function (response) {
          if (response.data.status) {
            _self.talent22 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData23 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "fang_wen_xue_zhe",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData23
      ).then(
        //事业单位
        function (response) {
          if (response.data.status) {
            _self.talent23 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData24 = {
        //科创专区
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "ke_chuang_zhuan_qu",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData24
      ).then(
        function (response) {
          if (response.data.status) {
            _self.talent24 = response.data.data;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "success",
          });
        }
      );
    },
    searchAfter() {
      //置顶去重

      let _self = this;

      let reqData11 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "gao_xiao",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData11
      ).then(
        //查询高等院校
        function (response) {
          if (response.data.status) {
            let talent11 = response.data.data;
            let newTalent = [],
              newStr = "";
            for (let p in _self.heightMsg) {
              newStr += _self.heightMsg[p].recruitId + ",";
            }
            for (let k in talent11) {
              if (newStr.indexOf(talent11[k].recruitId) < 0) {
                newTalent.push(talent11[k]);
              }
            }
            _self.talent11 = newTalent;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData12 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "ke_yan_yuan_suo",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData12
      ).then(
        //科研院所
        function (response) {
          if (response.data.status) {
            let talent12 = response.data.data;
            let newTalent = [],
              newStr = "";
            for (let p in _self.talentMsg) {
              newStr += _self.talentMsg[p].recruitId + ",";
            }
            for (let k in talent12) {
              if (newStr.indexOf(talent12[k].recruitId) < 0) {
                newTalent.push(talent12[k]);
              }
            }
            _self.talent12 = newTalent;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData13 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "shuo_bo_re_zhao",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData13
      ).then(
        //博士人才
        function (response) {
          if (response.data.status) {
            let talent13 = response.data.data;
            let newTalent = [],
              newStr = "";
            for (let p in _self.sevenleftBom) {
              newStr += _self.sevenleftBom[p].recruitId + ",";
            }
            for (let k in talent13) {
              if (newStr.indexOf(talent13[k].recruitId) < 0) {
                newTalent.push(talent13[k]);
              }
            }
            _self.talent13 = newTalent;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData14 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "bo_shi_hou",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=15",
        reqData14
      ).then(
        //博后
        function (response) {
          if (response.data.status) {
            let talent14 = response.data.data;
            let newTalent = [],
              newStr = "";
            for (let p in _self.sevenRightBom) {
              newStr += _self.sevenRightBom[p].recruitId + ",";
            }
            for (let k in talent14) {
              if (newStr.indexOf(talent14[k].recruitId) < 0) {
                newTalent.push(talent14[k]);
              }
            }
            _self.talent14 = newTalent;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
      let reqData25 = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: "",
        keyWord: "",
        categoryCode: "zhi_ye_qing_bao",
      };
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=17",
        reqData25
      ).then(
        //职场情报
        function (response) {
          if (response.data.status) {
            let personnelList = response.data.data;
            let newTalent = [],
              newStr = "";
            for (let p in _self.sevenRightBom) {
              newStr += _self.sevenRightBom[p].recruitId + ",";
            }
            for (let k in personnelList) {
              if (newStr.indexOf(personnelList[k].recruitId) < 0) {
                newTalent.push(personnelList[k]);
              }
            }
            _self.personnelList = newTalent;
          } else {
            console.log(response.data.message);
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
    },
    getTitleList() {
      let _self = this;
      get("front/dict/getTitleList", { dictType: "shou_ye" }).then(
        function (response) {
          if (response.data.status) {
            let resData = (_self.titleList = response.data.data);
            resData.map(function (value, index, arr) {
              switch (value.dictCode) {
                case 206: //行业新闻
                  _self.recommendTitle = value.dictLabel;
                  value.dictVos.map(function (value, index, array) {
                    switch (value.dictCode) {
                      case 225: //院校招聘
                        _self.recommendChildTitle1 = value.dictLabel;
                        break;
                      case 226: //出国讯息
                        _self.recommendChildTitle2 = value.dictLabel;
                        break;
                      case 227: //名企招聘
                        _self.recommendChildTitle3 = value.dictLabel;
                        break;
                    }
                  });
                  break;
                case 207: //人事动态
                  _self.dynamicTitle1 = value.dictLabel;
                  break;
                case 228: //最新求职者
                  _self.dynamicTitle2 = value.dictLabel;
                  break;
                case 229: //推荐岗位
                  _self.dynamicTitle3 = value.dictLabel;
                  break;
                case 230: //求职热点
                  _self.dynamicTitle4 = value.dictLabel;
                  break;
                case 231: //科研行业信息
                  _self.dynamicTitle5 = value.dictLabel;
                  _self.jobList = value.dictVos;
                  break;
                case 271: //高校人才招聘
                  _self.dynamicTitle7 = value.dictLabel;
                  break;
                case 272: //科研院所人才招聘
                  _self.dynamicTitle8 = value.dictLabel;
                  break;
                case 273: //人才专题
                  _self.dynamicTitle9 = value.dictLabel;
                  break;
                case 274: //博士人才招聘
                  _self.dynamicTitle10 = value.dictLabel;
                  break;
                case 275: //博士后人才招聘
                  _self.dynamicTitle11 = value.dictLabel;
                  break;
                case 277: //人事热点
                  _self.dynamicTitle12 = value.dictLabel;
                  break;
                case 278: //最新更新
                  _self.dynamicTitle13 = value.dictLabel;
                  break;
                case 279: //求职动态
                  _self.dynamicTitle14 = value.dictLabel;
                  break;
                case 280: //科研人才录取榜
                  _self.dynamicTitle15 = value.dictLabel;
                  break;
                case 281: //名企招聘榜单
                  _self.dynamicTitle16 = value.dictLabel;
                  break;
                case 282: //国际科研机构招聘
                  _self.dynamicTitle17 = value.dictLabel;
                  break;
                case 283: //职场聚焦
                  _self.dynamicTitle18 = value.dictLabel;
                  break;
                case 284: //高端人才求职
                  _self.dynamicTitle19 = value.dictLabel;
                  break;
                case 285: //就业精华
                  _self.dynamicTitle20 = value.dictLabel;
                  break;
                case 325: //最新职位
                  _self.dynamicTitle21 = value.dictLabel;
                  break;
                case 326: //行业动态
                  _self.dynamicTitle22 = value.dictLabel;
                  break;
                case 327: //最新职位
                  _self.dynamicTitle23 = value.dictLabel;
                  break;
                case 328: //科研相关
                  _self.dynamicTitle24 = value.dictLabel;
                  break;
                case 329: //人才数据
                  _self.dynamicTitle25 = value.dictLabel;
                  break;
                case 330: //科研机构
                  _self.dynamicTitle26 = value.dictLabel;
                  break;
              }
            });
          } else {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        },
        function (response) {
          // _self.$message({
          //     message: response.data.message,
          //     type: 'error'
          // });
        }
      );
    },
    initData(val) {
      let _self = this;

      let reqData = {
        city: "",
        province: "",
        dictCode: "",
        companyId: "",
        desc: val,
        keyWord: "",
      };
      if (val == 1) {
        reqData = {
          city: "",
          province: "",
          dictCode: "",
          companyId: "",
          desc: val,
          keyWord: "",
          queryResource: 0,
        };
      }
      postWithJson(
        "front/recruit/queryRecruit?pageNum=1&pageSize=17",
        reqData
      ).then(
        function (response) {
          if (response.data.status) {
            if (val == 3) {
              //访问次数
              _self.personnelList = response.data.data;
            } else if (val == 1) {
              //创建时间
              _self.newPosition = response.data.data.slice(0, 18);
              _self.newPosition.map(function (value, index, array) {
                if (index < 8) {
                  value.img = require("../assets/imgs/Group7" + index + ".png");
                }
              });
            } else if (val == 4) {
              //投递次数
              _self.hotJobs = response.data.data;
            }
          } else {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        },
        function (response) {
          _self.$message({
            message: "请重试",
            type: "error",
          });
        }
      );
    },
    changeDynamic(val) {
      this.changeDynamicFlag = val;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    logOut() {
      localStorage.setItem("_token", "");
      localStorage.setItem("_id", "");
      this.loginPersonFlag = false;
      this.loginCompanyFlag = false;
      localStorage.setItem("_userName", "");
      this.$message({
        message: "退出成功！",
        type: "success",
      });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 300) {
        this.navFlag = true;
      } else {
        this.navFlag = false;
      }
    },
  },
};
</script>

<style scoped = "scoped"  lang = "less">
.pc {
  background-color: #f4f4f4;

  .centers {
    margin-bottom: 40px;
    .content {
      width: 1200px;
      margin: 0 auto;
      /* overflow: hidden; */
      .city {
        margin: 0 0 20px;
        li {
          margin-left: 9px;
          width: 66px;
          height: 30px;
          line-height: 30px;
          border: 1px solid #cbdff3;
          background: rgba(245, 248, 252, 1);
          border-radius: 6px;
          text-align: center;
          margin-top: 10px;
          a {
            display: block;
            width: 66px;
            height: 30px;
            color: #333;
          }
          a:hover {
            color: rgba(23, 135, 251, 1);
          }
        }
        li:nth-child(16n + 1) {
          margin-left: 0px;
        }
        /* li:nth-child(15),li:nth-child(16),li:nth-child(17),li:nth-child(18),li:nth-child(19),
                li:nth-child(34),li:nth-child(35),li:nth-child(36),li:nth-child(37),li:nth-child(38){
                    margin-left: 10px;
                } */
      }
      /* 公告栏 */
      .announcement {
        width: 100%;
        height: 40px;
        overflow: hidden;
        vertical-align: middle;
        background-color: #fff;
        border: 1px solid rgba(226, 226, 226, 1);
        box-sizing: border-box;
        img {
          margin: 10px 20px;
          width: 20px;
        }
        .titles {
          width: 56px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(23, 135, 251, 1);
          line-height: 20px;
          margin: 10px 8px 0 0;
        }
        .announcementContent {
          width: 1050px;
          overflow: hidden;
          margin-top: 10px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(50, 95, 134, 1);
          line-height: 20px;
          ul {
            width: 30000px;
            a {
              color: rgba(50, 95, 134, 1);
            }
            span {
              margin: 0 6px;
            }
          }
          .animate {
            padding-left: 20px;
            font-size: 12px;
            color: #000;
            display: inline-block;
            white-space: nowrap;
            animation: 600s wordsLoop linear infinite normal;
          }
          .animate:hover {
            -webkit-animation-play-state: paused;
            animation-play-state: paused;
          }
          @keyframes wordsLoop {
            0% {
              transform: translateX(0px);
              -webkit-transform: translateX(0px);
            }
            100% {
              transform: translateX(-10000px);
              -webkit-transform: translateX(-10000px);
            }
          }

          @-webkit-keyframes wordsLoop {
            0% {
              transform: translateX(0);
              -webkit-transform: translateX(0);
            }
            100% {
              transform: translateX(-100%);
              -webkit-transform: translateX(-100%);
            }
          }
        }
      }
      /* 推荐 */
      .recommend {
        height: 168px;
        background-color: white;
        margin-top: 10px;
        padding: 10px;
        display: flex;
        .recommendLeft {
          margin-right: 20px;
          border-right: 2px solid rgba(255, 0, 0, 1);
          height: 100%;
          p {
            width: 46px;
            height: 100%;
            font-size: 20px;
            font-family: Helvetica;
            color: rgba(255, 0, 0, 1);
            line-height: 24px;
            padding: 26px 16px 0 10px;
          }
        }
        .recommendCon {
          padding-top: 20px;
          width: 532px;
          h3 {
            text-align: center;
            height: 20px;
            font-size: 20px;
            font-family: PingFangSC;
            font-weight: 600;
            color: rgba(23, 135, 251, 1);
            line-height: 20px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            width: 100%;
            a {
              color: #333;
              font-style: normal;
            }
          }
          p {
            text-align: center;
            height: 16px;
            font-size: 16px;
            font-family: PingFangSC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 16px;
            margin: 10px 0 16px;
          }
          li {
            width: 534px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC;
            font-weight: 600;
            color: rgba(23, 135, 251, 1);
            line-height: 22px;
            margin-top: 9px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            i {
              font-style: normal;
              color: #333;
            }
            i:hover {
              color: rgba(23, 135, 251, 1);
            }
          }
        }
        .recommendCon:last-child {
          margin-left: 30px;
        }
      }
      /* 人事动态 */
      .dynamic {
        margin-top: 20px;
        .dynamic_left {
          width: 428px;
          .left_carousel {
            width: 100%;
            height: 250px;
          }
          .left_company {
            margin-top: 10px;
            li {
              margin-left: 8px;
              margin-top: 1px;
              border: 1px solid transparent;
              width: 208px;
              height: 56px;
              overflow: hidden;
              img {
                display: block;
                width: 208px;
                height: 56px;
                transition: all 0.3s;
              }
            }
            li:hover {
              border: 1px solid red;
              img {
                transform: scale(1.15, 1.05);
              }
            }
            li:nth-child(2n + 1) {
              margin-left: 0;
            }
          }
        }
        .dynamic_center {
          width: 460px;
          height: 556px;
          background-color: white;
          border: 1px solid rgba(226, 226, 226, 1);
          margin: 0 10px;
          .dynamic_center_title {
            height: 38px;
            line-height: 38px;
            span {
              display: inline-block;
              width: 33.3%;
              text-align: center;
              box-sizing: border-box;
              height: 100%;
              color: #333333;
              font-size: 16px;
              border-right: 1px solid rgba(226, 226, 226, 1);
              border-bottom: 1px solid rgba(226, 226, 226, 1);
              background-color: #f4f4f4;
              cursor: pointer;
            }
            span:last-child {
              border-right: none;
            }
            .actived {
              color: #1787fb;
              background-color: white;
              border-bottom: none;
            }
          }
          .dynamic_center_content {
            padding: 10px 20px 23px;

            p {
              height: 22px;
              line-height: 22px;
              margin-bottom: 5px;
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              font-weight: 600;
              .circle {
                display: inline-block;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: #1787fb;
                margin-top: 8px;
                margin-right: 10px;
              }
              a {
                color: #333;
                display: inline-block;
                width: 400px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: 22px;
                font-size: 14px;
                i {
                  font-style: normal;
                  color: #1787fb;
                }
              }
              a:hover {
                color: #1787fb;
              }
              .detailTime {
                font-size: 14px;
                color: #999;
              }
            }
            p:last-child {
              margin-bottom: 0;
            }
            .theImportant {
              a {
                color: #ff0000;
                i {
                  color: #ff0000;
                }
              }
            }
            .more {
              margin-top: 10px;
              a {
                border-bottom: none;
                text-align: center;
                font-size: 12px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: #1787fb;
              }
            }
          }
        }
        .dynamic_right {
          width: 292px;
          a {
            display: inline-block;
            width: 136px;
            overflow: hidden;
            margin-top: 13px;
            img {
              display: block;
              width: 136px;
              height: 104px;
              transition: all 0.3s;
            }
            p {
              width: 136px;
              height: 20px;
              font-size: 13px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              color: rgba(23, 135, 251, 1);
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: center;
              margin-top: 5px;
            }
          }
          a:hover {
            p {
              color: #ff0000;
            }
            img {
              transform: scale(1.15, 1.15);
            }
          }
          a:first-child,
          a:nth-child(2) {
            margin-top: 0;
          }
          a:nth-child(2n) {
            margin-left: 20px;
          }
        }
      }
      /* 行业动态 */
      .industryMsg {
        height: 372px;
        margin-top: 20px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(226, 226, 226, 1);
        padding: 0 20px;
        .indestry_title {
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #e2e2e2;
          h3 {
            font-size: 20px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: rgba(23, 135, 251, 1);
            width: 200px;
          }
          p {
            font-size: 16px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            line-height: 50px;
            span {
              display: inline-block;
              margin-right: 36px;
              height: 47px;
              line-height: 47px;
              cursor: pointer;
              border-bottom: 3px solid transparent;
              box-sizing: border-box;
            }
            .actived1 {
              border-color: #1787fb;
            }
          }
          .more {
            width: 73px;
            font-size: 14px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: rgba(23, 135, 251, 1);
          }
          .more:hover {
            color: #ff0000;
          }
        }
        .indestry_content {
          height: 322px;
          .indestry_content_left {
            width: 200px;
            overflow: hidden;
            height: 100%;
            h4 {
              font-size: 14px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              margin-top: 14px;
            }
            a {
              font-size: 14px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              line-height: 18px;
              height: 18px;
              margin-top: 20px;
              width: 50%;
              overflow: hidden;
              vertical-align: middle;
              /* padding-left: 10px; */
              span {
                display: inline-block;
                width: 4px;
                height: 4px;
                background: rgba(216, 216, 216, 1);
                border-radius: 50%;
                margin-right: 6px;
                vertical-align: middle;
              }
            }
          }
          .indestry_content_right {
            width: 958px;
            height: 100%;
            padding-top: 14px;
            a {
              width: 224px;
              margin-left: 18px;
              height: 140px;
              overflow: hidden;
              img {
                display: block;
                width: 224px;
                height: 112px;
                transition: all 0.3s;
              }
              p {
                width: 224px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
                font-size: 12px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                line-height: 18px;
                height: 18px;
                margin-top: 6px;
                text-align: center;
              }
            }
            a:hover {
              p {
                color: #ff0000;
                text-decoration: underline;
              }
              img {
                transform: scale(1.05, 1.05);
              }
            }
            a:first-child,
            a:nth-child(5) {
              margin-left: 0;
            }
            a:nth-child(5),
            a:nth-child(6),
            a:nth-child(7),
            a:nth-child(8) {
              margin-top: 10px;
            }
          }
        }
      }
      .comList {
        margin-top: 10px;
        a {
          width: 232px;
          background-color: white;
          border: 1px solid rgba(226, 226, 226, 1);
          box-sizing: border-box;
          overflow: hidden;
          text-align: center;
          margin-left: 10px;
          margin-top: 10px;
          img {
            display: block;
            width: 232px;
            height: 70px;
          }
          p {
            text-align: center;
            height: 28px;
            line-height: 28px;
            width: 232px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(50, 95, 134, 1);
            border-top: 1px solid rgba(226, 226, 226, 1);
          }
        }
        a:hover {
          -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); /*添加阴影*/
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
          -webkit-transform: translate3d(0, -2px, 0); /*向上浮动*/
          transform: translate3d(0, -2px, 0);
          p {
            color: #1787fb;
          }
        }
        a:nth-child(5n + 1) {
          margin-left: 0px;
        }
      }
      /* 科研人才 高校人才 */
      .talent {
        margin-top: 20px;
        .talent_left,
        .talent_right {
          width: 590px;
          .talent_title {
            width: 100%;
            font-size: 16px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            height: 47px;
            line-height: 38px;
            margin-bottom: 6px;
            background: url("~@/assets/imgs/Combined Shape 2.png") no-repeat
              center center;
          }
          .talent_school {
            margin-bottom: 10px;
            a {
              margin-left: 15px;
            }
            a:nth-child(4n + 1) {
              margin-left: 0;
            }
            img {
              display: block;
              width: 136px;
              height: 102px;
              transition: all 0.3s;
            }
            p {
              width: 134px;
              height: 20px;
              font-size: 13px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              color: rgba(23, 135, 251, 1);
              line-height: 20px;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            a:hover {
              p {
                color: #ff0000;
              }
              img {
                transform: scale(1.1, 1.05);
              }
            }
          }
          .talent_list {
            width: 100%;
            a {
              margin-bottom: 10px;
              margin-left: 10px;
              background-color: #fff;
              img {
                display: block;
                width: 290px;
                height: 58px;
              }
              img:hover {
                box-shadow: 0 2px 10px #999;
              }
            }
            a:nth-child(2n + 1) {
              margin-left: 0;
            }
          }
          .talent_con {
            width: 100%;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(229, 229, 229, 1);
            padding: 10px;
            height: 510px;
            a {
              height: 29px;
              line-height: 29px;
              border-bottom: 1px dashed #d1d1d1;
              font-size: 14px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              display: block;
              .circle {
                display: inline-block;
                border-radius: 50%;
                width: 6px;
                height: 6px;
                background: rgba(23, 135, 251, 1);
                margin-right: 6px;
                margin-top: 12px;
              }
              .topping {
                color: #ee6464;
              }
              .title {
                color: #333;
                display: inline-block;
                width: 540px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .detail {
                margin-right: 10px;
                font-size: 14px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: rgba(23, 135, 251, 1);
                font-style: normal;
              }
            }
            .diff {
              .title {
                width: 480px;
              }
            }
            a:hover {
              .title {
                color: #0088ff;
              }
            }
            .more {
              margin-top: 16px;
              a {
                border-bottom: none;
                text-align: center;
                font-size: 12px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: rgba(23, 135, 251, 1);
              }
            }
          }
        }
        .talent_right {
          width: 590px;
          .talent_title2 {
            background: url("~@/assets/imgs/Combined Shape 3.png") no-repeat
              center center;
          }
        }
      }
      /* 人才专题 */
      .talentTopic {
        margin-top: 20px;
        width: 100%;
        height: 262px;
        background-color: white;
        padding-top: 12px;
        padding-left: 24px;
        h3 {
          font-size: 20px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          overflow: hidden;
          height: 28px;
          width: 1176px;
          span {
            display: inline-block;
            width: 5px;
            height: 20px;
            background: rgba(23, 135, 251, 1);
            margin-right: 7px;
            margin-top: 4px;
          }
          i {
            font-style: normal;
          }
        }
        .talentTopic_block {
          margin-top: 20px;
          width: 220px;
          height: 180px;
          border: 1px solid rgba(226, 226, 226, 1);
          overflow: hidden;
          margin-left: 14px;
          img {
            width: 220px;
            height: 130px;
            display: block;
          }
          h4 {
            font-size: 14px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            text-align: center;
            overflow: hidden;
            height: 22px;
            margin: 8px 0;
          }
          p {
            margin-top: 4px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            width: 200px;
            margin-left: 10px;
            height: 40px;
            line-height: 20px;
          }
        }
        .talentTopic_block:first-of-type {
          margin-left: 0;
        }
        .talentTopic_block:hover {
          box-shadow: 0 0 10px #ccc;
        }
      }
      /* 人事热点 最新更新 求职动态 */
      .hotSpot {
        margin-top: 20px;
        .hotSpot_left,
        .hotSpot_right,
        .hotSpot_center {
          width: 390px;
          height: 470px;
          background-color: white;
          padding: 0 20px;
          .more {
            margin-top: 6px;
            text-align: center;
            a {
              border-bottom: none;
              text-align: center;
              font-size: 12px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              color: #1787fb;
            }
          }
          h3 {
            height: 44px;
            line-height: 44px;
            border-bottom: 1px solid #e2e2e2;
            span {
              width: 5px;
              height: 20px;
              display: inline-block;
              background: rgba(23, 135, 251, 1);
              margin-right: 7px;
              margin-top: 12px;
            }
            i {
              font-size: 20px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              font-style: normal;
            }
          }
          ul {
            margin-top: 20px;
            li {
              height: 24px;
              line-height: 24px;
              vertical-align: middle;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
              .circle {
                display: inline-block;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background-color: #999;
                vertical-align: middle;
                margin-right: 8px;
              }
              i {
                font-size: 14px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                font-style: normal;
              }
            }
            li:hover {
              /* text-decoration: underline; */
              i {
                /* font-size: 15px; */
                color: #1787fb;
              }
            }
          }
        }
        .hotSpot_center {
          margin-left: 15px;
        }
        /* .hotSpot_center{
                    width: 390px;
                    height: 386px;
                    background-color: white;
                    margin-left: 15px;
                    h3{
                        height: 48px;
                        line-height: 48px;
                        border-bottom: 1px solid #e2e2e2;
                        margin: 0 20px;
                        span{
                            width:5px;
                            height:20px;
                            display: inline-block;
                            background:rgba(23,135,251,1);
                            margin-right: 7px;
                            margin-top: 12px;
                        }
                        i{
                            font-size:20px;
                            font-family:PingFangSC-Medium;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                            font-style: normal;
                        }
                    }
                    ul{
                        margin-top: 12px;
                        padding: 0 10px;
                        li{
                            height: 30px;
                            line-height: 30px;
                            vertical-align: middle;
                            width: 100%;
                            border-bottom: 1px dashed #e2e2e2;
                            .circle{
                                display: inline-block;
                                width: 6px;
                                height: 6px;
                                border-radius: 50%;
                                background-color: #1787FB;
                                vertical-align: middle;
                                margin-right: 6px;
                                margin-top: 10px;
                            }
                            i{
                                font-size:14px;
                                font-family:PingFangSC-Medium;
                                font-weight:500;
                                color:rgba(51,51,51,1);
                                font-style: normal;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                width: 354px;
                                span{
                                    color: #94D639;
                                }
                            }
                            .fr{
                                font-size:14px;
                                font-family:PingFangSC-Regular;
                                font-weight:400;
                                color:rgba(153,153,153,1);
                            }
                            i:hover{
                                color: #1787fb;
                            }
                        }
                    }
                    .more{
                        margin-top:16px;
                        text-align: center;
                        a{
                            text-align: center;
                            font-size: 12px;
                            font-family: PingFangSC-Regular;
                            font-weight: 400;
                            color: #1787fb;
                        }
                    }
                } */
      }
      /* 榜单 */
      .moreList {
        margin-top: 20px;
        background-color: white;
        border: 1px solid rgba(226, 226, 226, 1);
        .moreList_title {
          width: 100%;
          height: 40px;
          line-height: 40px;
          span {
            display: inline-block;
            width: 33.3%;
            text-align: center;
            box-sizing: border-box;
            height: 100%;
            color: #333333;
            font-size: 18px;
            border-right: 1px solid rgba(226, 226, 226, 1);
            border-bottom: 1px solid rgba(226, 226, 226, 1);
            background-color: #f4f4f4;
            cursor: pointer;
          }
          span:last-child {
            border-right: none;
          }
          .actived {
            color: #1787fb;
            background-color: white;
            border-bottom: none;
          }
        }
        .moreList_content {
          padding: 12px 10px;
          ul {
            padding-left: 10px;
            margin-top: 6px;
            width: 900px;
            li {
              height: 22px;
              line-height: 22px;
              margin-bottom: 5px;
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              font-weight: 600;
              width: 430px;
              .circle {
                display: inline-block;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: #1787fb;
                margin-top: 8px;
                margin-right: 10px;
              }
              a {
                color: #333;
                display: inline-block;
                width: 310px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: 22px;
                font-size: 14px;
                i {
                  font-style: normal;
                  color: #1787fb;
                }
              }
              .detailTime {
                color: #999;
                display: inline-block;
                width: 100px;
                overflow: hidden;
                text-align: center;
              }
            }
            li:hover {
              a {
                color: #1787fb;
              }
            }
            li:last-child {
              margin-bottom: 0;
            }
            li:nth-child(2n) {
              margin-left: 20px;
            }
            .theImportant {
              a {
                color: #ff0000;
                i {
                  color: #ff0000;
                }
              }
            }
          }
          a {
            img {
              width: 270px;
              height: 155px;
            }
          }
        }
      }
      /* 职场充能 */
      .onlyImg {
        display: block;
        margin-top: 20px;
        width: 100%;
        height: 140px;
        img {
          width: 100%;
          height: 140px;
          display: block;
        }
        img:hover {
          -webkit-box-shadow: 0 15px 10px rgba(0, 0, 0, 0.2); /*添加阴影*/
          box-shadow: 0 15px 10px rgba(0, 0, 0, 0.2);
          -webkit-transform: translate3d(0, -4px, 0); /*向上浮动*/
          transform: translate3d(0, -4px, 0);
        }
      }
      /* 职场聚焦 */
      .workPlace {
        margin-top: 20px;
        width: 100%;
        /* height: 460px; */
        .workModule {
          width: 390px;
          height: 460px;
          background-color: white;
          padding: 0 20px;
          margin-left: 14px;
          margin-bottom: 20px;
          .more {
            text-align: center;
            a {
              border-bottom: none;
              text-align: center;
              font-size: 12px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              color: #1787fb;
            }
          }
          h3 {
            height: 44px;
            line-height: 44px;
            border-bottom: 1px solid #e2e2e2;
            span {
              width: 5px;
              height: 20px;
              display: inline-block;
              background: rgba(23, 135, 251, 1);
              margin-right: 7px;
              margin-top: 12px;
            }
            i {
              font-size: 20px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              font-style: normal;
            }
          }
          .workImg {
            margin-top: 24px;
            img {
              width: 110px;
              height: 110px;
            }
          }
          ul {
            margin-top: 20px;
            /* margin-left: 17px; */
            width: 350px;
            li {
              height: 24px;
              line-height: 24px;
              vertical-align: middle;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .circle {
                display: inline-block;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background-color: #999;
                vertical-align: middle;
                margin-right: 8px;
              }
              i {
                font-size: 14px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: #333;
                font-style: normal;
              }
              i:hover {
                color: #1787fb;
              }
            }
          }
        }
        .workModule:first-child {
          margin-left: 0;
        }
      }
      .bottomImg {
        margin-top: 20px;
        .threee {
          margin-top: 10px;
          a {
            margin-left: 10px;
          }
          img {
            width: 393px;
            height: 50px;
            display: block;
          }
          a:first-child {
            margin-left: 0;
          }
        }
        .one {
          margin-top: 10px;
          img {
            display: block;
            width: 1200px;
            height: 50px;
          }
        }
        img:hover {
          box-shadow: 0 0 10px #333;
          transform: scale(1.01, 1.02);
        }
      }
    }
  }
}
@media all and (max-width: 768px) {
  .city,
  .announcement,
  .pc .centers .content .recommend,
  .dynamic_center,
  .dynamic_right,
  .left_company,
  .industryMsg,
  .talentTopic,
  .moreList,
  .bottomImg {
    display: none;
  }
  .centers {
    width: 100%;
    /* overflow: hidden; */
  }
  .pc .centers .content {
    width: 100%;
  }
  .pc .centers .content .dynamic .dynamic_left {
    width: 100%;
  }
  .talent {
    width: 100%;
  }
  .pc .centers .content .talent .talent_left,
  .pc .centers .content .talent .talent_right {
    width: 100%;
  }

  .pc .centers .content .talent .talent_left .talent_list a img,
  .pc .centers .content .talent .talent_right .talent_list a img {
    width: 100%;
  }
  .pc .centers .content .talent .talent_left .talent_list a,
  .pc .centers .content .talent .talent_right .talent_list a {
    margin-left: 0;
  }
  .pc .centers .content .talent .talent_left .talent_list a,
  .pc .centers .content .talent .talent_right .talent_list a {
    width: 45%;
    margin-left: 3%;
  }
  .pc .centers .content .talent .talent_left .talent_list a:nth-child(2n + 1),
  .pc .centers .content .talent .talent_right .talent_list a:nth-child(2n + 1) {
    margin-left: 3%;
  }
  .pc .centers .content .talent .talent_left .talent_con a .topping,
  .pc .centers .content .talent .talent_right .talent_con a .topping {
    width: 20%;
  }
  .pc .centers .content .talent .talent_left .talent_con a .title,
  .pc .centers .content .talent .talent_right .talent_con a .title {
    width: 90%;
  }
  .talent_right {
    margin-top: 16px;
  }
  .pc .centers .content .comList a {
    width: 45%;
    margin-left: 3%;
  }
  .pc .centers .content .comList a:nth-child(5n + 1) {
    width: 45%;
    margin-left: 3%;
  }
  .pc .centers .content .comList a img {
    width: 100%;
  }
  .pc .centers .content .comList a p {
    width: 100%;
  }
  .pc .centers .content .talent .talent_left .talent_school a,
  .pc .centers .content .talent .talent_right .talent_school a {
    width: 45%;
    margin-left: 3%;
    margin-bottom: 6px;
  }
  .pc .centers .content .talent .talent_left .talent_school a:nth-child(4n + 1),
  .pc
    .centers
    .content
    .talent
    .talent_right
    .talent_school
    a:nth-child(4n + 1) {
    margin-left: 3%;
  }
  .pc .centers .content .talent .talent_left .talent_school img,
  .pc .centers .content .talent .talent_right .talent_school img {
    width: 100%;
  }
  .pc .centers .content .talent .talent_left .talent_school p,
  .pc .centers .content .talent .talent_right .talent_school p {
    width: 100%;
  }
  .pc .centers .content .hotSpot .hotSpot_left,
  .pc .centers .content .hotSpot .hotSpot_right,
  .pc .centers .content .hotSpot .hotSpot_center {
    width: 100%;
    margin-top: 16px;
  }
  .pc .centers .content .hotSpot .hotSpot_center {
    margin-left: 0;
  }
  .pc .centers .content .hotSpot {
    margin-top: 0;
  }
  .pc .centers .content .workPlace .workModule {
    width: 100%;
    margin-left: 0;
  }
  .pc .centers .content .workPlace .workModule ul {
    width: 100%;
  }
  .pc .centers .content .talent .talent_left .talent_con .diff .title,
  .pc .centers .content .talent .talent_right .talent_con .diff .title {
    width: 70%;
  }
}
</style>
<style  lang = "less">
/* 轮播图 样式重置 */
.dynamic_left .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.dynamic_left .el-carousel__indicator--horizontal {
  padding: 6px 4px;
}
.dynamic_left .is-active .el-carousel__button {
  background-color: #1787fb;
}
.diffVal .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.diffVal .el-carousel__indicator--horizontal {
  padding: 6px 4px;
}
.diffVal .is-active .el-carousel__button {
  background-color: #1787fb;
}
</style>




// WEBPACK FOOTER //
// src/views/index.vue